module.exports = __webpack_public_path__ + "img/passplus.ad51f69a.png";